module.exports = __webpack_public_path__ + "static/img/mtlogo2.a155bc71.png";